<template>
<div>
    <div v-if="!validLocations.length" class="text-danger">{{ translations.noResults }}</div>
    <table v-if="validLocations.length" class="c-location-modal__table table">
        <thead>
            <tr>
                <th>{{ translations.offices }}</th>
                <th>{{ translations.address }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="location in validLocations" v-bind:key="location.id">
                <td><a :href="location.url" class="c-cta h-theme--red">{{ location.name }}</a></td>
                <td>{{ location.address1 }} {{ location.address2 }}</td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script>
export default {
    props: {
        locations: {
            type: Array,
            requires: true,
            default: []
        },
        translations: {
            type: Object,
            required: true
        }
    },
    computed: {
        validLocations: function() {
            return this.locations.filter(location => location.url !== '');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/app/components/location-selector-table.vue